export const STATUS = {
  REQUEST: 'REQUEST',
  ASSIGN: 'ASSIGN',
  ONGOING: 'ONGOING',
  BOOKING: 'BOOKING',
  BOOKED: 'BOOKED',
  ROUND_COMPLETED: 'ROUND_COMPLETED',
  STALE: 'STALE',
  WAITING_FOR_REVIEW: 'WAITING_FOR_REVIEW',
  SUCCESSFUL: 'SUCCESSFUL',
  OFFERED: 'OFFERED',
  OFFER_ACCEPTED: 'OFFER_ACCEPTED',
  OFFER_REJECTED: 'OFFER_REJECTED',
  SOFT_REJECTED: 'SOFT_REJECTED',
  REJECTED: 'REJECTED',
  HARD_REJECTED: 'HARD_REJECTED',
};

export const OVER_ALL_STATUS = {
  ONGOING_MAIN: 'ONGOING_MAIN',
  COMPLETED_MAIN: 'COMPLETED_MAIN',
  ON_HOLD_MAIN: 'ON_HOLD_MAIN',
};

export const INTERVIEW_SLOT = {
  AVAILABLE: 'available',
  BOOKED: 'booked',
};

export const VERDICT = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
};

export const ROUND_INFO = {
  round_1: {
    roundId: 'round_1',
    roundInfo: 'This is Apptitude Round',
    roundType: 'PC',
    HRComments: '',
    interviewerComments: '',
    intervieweeComments: '',
    status: '',
    interviewerReview: '',
    interviewerVerdit: '',
    joiningLink: '',
    interviewerId: '',
    intervieweeId: '',
    jobId: '',
    HRid: '',
    createdAt: '',
    updatedAt: '',
    interviewTimeAndDate: '',
  },
  round_2: {
    roundId: 'round_2',
    roundInfo: 'This is Telephonic Round',
    roundType: 'Phone',
    HRComments: '',
    interviewerComments: '',
    intervieweeComments: '',
    status: '',
    interviewerReview: '',
    interviewerVerdit: '',
    joiningLink: '',
    interviewerId: '',
    intervieweeId: '',
    jobId: '',
    HRid: '',
    createdAt: '',
    updatedAt: '',
    interviewTimeAndDate: '',
  },
  round_3: {
    roundId: 'round_3',
    roundInfo: 'This is Technical Round',
    roundType: 'PC',
    HRComments: '',
    interviewerComments: '',
    intervieweeComments: '',
    status: '',
    interviewerReview: '',
    interviewerVerdit: '',
    joiningLink: '',
    interviewerId: '',
    intervieweeId: '',
    jobId: '',
    HRid: '',
    createdAt: '',
    updatedAt: '',
    interviewTimeAndDate: '',
  },
  round_4: {
    roundId: 'round_4',
    roundInfo: 'This is Technical Round 2',
    roundType: 'PC',
    HRComments: '',
    interviewerComments: '',
    intervieweeComments: '',
    status: '',
    interviewerReview: '',
    interviewerVerdit: '',
    joiningLink: '',
    interviewerId: '',
    intervieweeId: '',
    jobId: '',
    HRid: '',
    createdAt: '',
    updatedAt: '',
    interviewTimeAndDate: '',
  },
};
